"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2409],{

/***/ 93960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LS": function() { return /* binding */ setItem; },
/* harmony export */   "MU": function() { return /* binding */ setListener; },
/* harmony export */   "cl": function() { return /* binding */ removeItem; },
/* harmony export */   "rV": function() { return /* binding */ getItem; }
/* harmony export */ });
var safeGetLocalStorage = function() {
    try {
        return window === null || window === void 0 ? void 0 : window.localStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to local storage
        return undefined;
    }
};
var setListener = function(cb) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    window.addEventListener("storage", function(e) {
        cb(e);
    });
};
var setItem = function(key, value) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
};
var getItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return string ? JSON.parse(string) : string;
};
var removeItem = function(key) {
    var storage = safeGetLocalStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
};


/***/ }),

/***/ 37175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rV": function() { return /* binding */ getItem; },
  "cl": function() { return /* binding */ removeItem; },
  "LS": function() { return /* binding */ setItem; }
});

// UNUSED EXPORTS: isAvailable

// EXTERNAL MODULE: ../../../../browser-sdk/src/libraries/local-storage.ts
var local_storage = __webpack_require__(93960);
;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/broadcast-message.js

function broadcastMessageToTabs(key, value) {
    (0,local_storage/* setItem */.LS)(key, value);
    (0,local_storage/* removeItem */.cl)(key);
}

;// CONCATENATED MODULE: ../../../../browser-sdk/src/libraries/session-storage.js

function safeGetSessionStorage() {
    try {
        return window === null || window === void 0 ? void 0 : window.sessionStorage;
    } catch (_err) {
        // Catch a SecurityError that is thrown if the browser has disabled access
        // to session storage
        return undefined;
    }
}
function isAvailable() {
    return !!safeGetSessionStorage();
}
function getItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return undefined;
    }
    var string = storage.getItem(key);
    return JSON.parse(string);
}
function setItem(key, value) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _broadcast = ref.broadcast, broadcast = _broadcast === void 0 ? false : _broadcast;
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    var stringToStore = JSON.stringify(value);
    storage.setItem(key, stringToStore);
    if (broadcast) {
        broadcastMessageToTabs("BROADCAST", {
            key: key,
            data: value
        });
    }
}
function removeItem(key) {
    var storage = safeGetSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(key);
}


/***/ }),

/***/ 85391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23670);
/* harmony import */ var _purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93960);
/* harmony import */ var _components_common_segment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5721);




function isInternalUser() {
    var internalUser = (0,_purple_dot_browser_sdk_src_libraries_local_storage__WEBPACK_IMPORTED_MODULE_1__/* .getItem */ .rV)("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
}
function isKnownBot() {
    var BOTS = /(pingdom)|(google)/i;
    return __webpack_require__.g.navigator.userAgent.match(BOTS);
}
var FilterWrapper = {
    identify: function identify(userId, traits, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.identify */ .W.identify(userId, traits, options, callback);
        } else {
            // biome-ignore lint/nursery/noConsole: debug
            console.log("INTERNAL USER - Identify: ", userId);
        }
    },
    track: function track(event, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.track */ .W.track(event, properties, options, callback);
        } else {
            // biome-ignore lint/nursery/noConsole: debug
            console.log("INTERNAL USER - Track: ", event, properties, options, callback);
        }
    },
    page: function page(category, name, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            _components_common_segment__WEBPACK_IMPORTED_MODULE_0__/* .SegmentWrapper.page */ .W.page(category, name, properties, options, callback);
        } else {
            // biome-ignore lint/nursery/noConsole: debug
            console.log("INTERNAL USER - Page: ", category, name, properties, options, callback);
        }
    }
};
var Analytics = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, FilterWrapper), {
    trackTagScanned: function trackTagScanned(param) {
        var itemId = param.itemId, scannedCode = param.scannedCode, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackTagScanned()");
        }
        if (!scannedCode) {
            throw new Error("No scannedCode provided to Analytics.trackTagScanned()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackTagScanned()");
        }
        FilterWrapper.track("Tag Scanned", {
            itemId: itemId,
            scannedCode: scannedCode,
            shopCode: shopCode
        });
    },
    trackCodeEntered: function trackCodeEntered(param) {
        var enteredCode = param.enteredCode, codeType = param.codeType;
        if (!enteredCode) {
            throw new Error("No enteredCode provided to Analytics.trackCodeEntered()");
        }
        if (!codeType) {
            throw new Error("No codeType provided to Analytics.trackCodeEntered()");
        }
        if (codeType === "tag") {
            FilterWrapper.track("Tag Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "item") {
            FilterWrapper.track("Shareable Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "external") {
            FilterWrapper.track("External Shop Code Entered", {
                enteredCode: enteredCode
            });
        }
    },
    trackInstagramLinkFollowed: function trackInstagramLinkFollowed(param) {
        var itemId = param.itemId, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackInstagramLinkFollowed()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackInstagramLinkFollowed()");
        }
        FilterWrapper.track("Instagram Link Followed", {
            itemId: itemId,
            shopCode: shopCode
        });
    },
    trackImageGalleryInteraction: function trackImageGalleryInteraction(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackImageViewed()");
        }
        FilterWrapper.track("Interacted with Image Gallery", {
            itemId: itemId
        });
    },
    trackProductViewed: function trackProductViewed(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackCheckoutStarted: function trackCheckoutStarted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackCheckoutStarted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackCheckoutStarted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackCheckoutStarted()");
        }
        FilterWrapper.track("Checkout Started", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderSubmitted: function trackOrderSubmitted(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackOrderSubmitted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackOrderSubmitted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackOrderSubmitted()");
        }
        FilterWrapper.track("Order Submitted", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug
        });
    },
    trackOrderCreated: function trackOrderCreated(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackOrderFailed: function trackOrderFailed() {
        FilterWrapper.track("Order Failed");
    },
    trackShippingMethodSelected: function trackShippingMethodSelected(param) {
        var shippingOption = param.shippingOption;
        if (!shippingOption) {
            throw new Error("No shippingOption provided to Analytics.trackShippingMethodSelected()");
        }
        FilterWrapper.track("Shipping Method Selected", {
            shippingOption: shippingOption
        });
    },
    trackPaymentMethodSelected: function trackPaymentMethodSelected(param) {
        var paymentMethod = param.paymentMethod;
        if (!paymentMethod) {
            throw new Error("No paymentMethod provided to Analytics.trackPaymentMethodSelected()");
        }
        FilterWrapper.track("Payment Method Selected", {
            paymentMethod: paymentMethod
        });
    },
    trackLearnMoreClicked: function trackLearnMoreClicked() {
        FilterWrapper.track("Learn More Clicked");
    },
    trackLearnMoreModalDismissed: function trackLearnMoreModalDismissed() {
        FilterWrapper.track("Learn More Modal Dismissed");
    },
    trackSizeChanged: function trackSizeChanged(param) {
        var itemId = param.itemId, selectedItemId = param.selectedItemId, slug = param.slug;
        FilterWrapper.track("Size Changed", {
            itemId: itemId,
            selectedItemId: selectedItemId,
            slug: slug
        });
    },
    trackMerchantItemUrlVisit: function trackMerchantItemUrlVisit(param) {
        var source = param.source, itemMerchantUrl = param.itemMerchantUrl;
        FilterWrapper.track("Item Merchant Link Visited", {
            source: source,
            itemMerchantUrl: itemMerchantUrl
        });
    },
    trackTrendingItemSelected: function trackTrendingItemSelected(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Trending Item Selected", {
            itemId: itemId,
            slug: slug
        });
    },
    trackTrendingScrolled: function trackTrendingScrolled() {
        FilterWrapper.track("Trending Scrolled");
    },
    trackRetailerModalOpened: function trackRetailerModalOpened() {
        FilterWrapper.track("Retailer Modal Opened");
    },
    trackShareModalOpened: function trackShareModalOpened(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Share Modal Opened", {
            itemId: itemId,
            slug: slug
        });
    },
    trackLastSeenProductClicked: function trackLastSeenProductClicked() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function trackInputChanged(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackSectionExpanded: function trackSectionExpanded(param) {
        var title = param.title;
        if (!title) {
            throw new Error("No title provided to Analytics.trackSectionExpanded");
        }
        FilterWrapper.track("".concat(title, " Expanded"));
    },
    trackShareLinkFollowed: function trackShareLinkFollowed(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No title provided to Analytics.trackShareLinkFollowed");
        }
        FilterWrapper.track("Unique Product Share Link Followed", {
            itemId: itemId
        });
    },
    trackNewsletterSignup: function trackNewsletterSignup() {
        FilterWrapper.track("Newsletter Sign Up");
    },
    trackSuggestClicked: function trackSuggestClicked() {
        FilterWrapper.track("Suggest an Item Clicked");
    },
    trackSuggestionSubmitted: function trackSuggestionSubmitted() {
        FilterWrapper.track("Suggestion Submitted");
    },
    trackExplainerVideoPlayed: function trackExplainerVideoPlayed() {
        FilterWrapper.track("Explainer Video Played");
    },
    trackExplainerVideoPaused: function trackExplainerVideoPaused(param) {
        var timeViewed = param.timeViewed;
        FilterWrapper.track("Explainer Video Paused", {
            timeViewed: timeViewed
        });
    },
    trackUserProgressed: function trackUserProgressed(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    },
    trackUserEngagedWithLandingPage: function trackUserEngagedWithLandingPage(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserEngagedWithLandingPage");
        }
        FilterWrapper.track("Engaged With Landing Page", {
            pageName: pageName
        });
    },
    trackSizeGuideClicked: function trackSizeGuideClicked() {
        FilterWrapper.track("Size Guide Clicked");
    },
    trackVisitDemoStoreClicked: function trackVisitDemoStoreClicked() {
        FilterWrapper.track("Visit Demo Store Clicked");
    },
    trackGetInTouchClicked: function trackGetInTouchClicked() {
        FilterWrapper.track("Get In Touch Clicked");
    },
    trackMerchantContactFormSubmitted: function trackMerchantContactFormSubmitted() {
        FilterWrapper.track("Merchant Contact Form Submitted");
    },
    trackStoreSignupReview: function trackStoreSignupReview() {
        FilterWrapper.track("Store Review Form Submitted");
    },
    trackSurveyCTAClick: function trackSurveyCTAClick() {
        FilterWrapper.track("Survey CTA Clicked");
    }
});
/* harmony default export */ __webpack_exports__["Z"] = (Analytics);


/***/ }),

/***/ 18531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14432);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7464);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60586);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90171);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62546);
/* harmony import */ var _common_ThemedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57565);
/* harmony import */ var _common_media_queries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62540);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 75%;\n  padding: 18px;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(_param) /*#__PURE__*/ {
    var className = _param.className, children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(PositionedButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            "data-testid": "next-button"
        }, rest), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                children: children
            })
        }))
    });
})(_templateObject());
var PositionedButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_common_ThemedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject1(), _common_media_queries__WEBPACK_IMPORTED_MODULE_4__/* .BelowMobile */ .fB);


/***/ }),

/***/ 9365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ postCheckoutLoaded; },
/* harmony export */   "Bp": function() { return /* binding */ postGoToHomepage; },
/* harmony export */   "EI": function() { return /* binding */ postCloseCartClicked; },
/* harmony export */   "J5": function() { return /* binding */ postPreorderCheckoutStep; },
/* harmony export */   "PU": function() { return /* binding */ postClosedMessage; },
/* harmony export */   "lP": function() { return /* binding */ postCartCheckoutClicked; },
/* harmony export */   "qr": function() { return /* binding */ postResizeMessage; },
/* harmony export */   "ux": function() { return /* binding */ trackCombinedPreorderCreated; },
/* harmony export */   "wH": function() { return /* binding */ postPreorderCheckoutSubmitted; },
/* harmony export */   "yu": function() { return /* binding */ postCartCleared; },
/* harmony export */   "zY": function() { return /* binding */ postPreorderFailed; }
/* harmony export */ });
/* unused harmony exports postPreorderCreated, postOrderCreated, trackOrderCreated, trackPreorderCreated, toTrackingOrderObject, toCombinedTrackingOrderObject */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68641);
// Lifecycle

function postResizeMessage(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PD_PLACEMENT_RESIZE"
    }, data));
}
function postCartCheckoutClicked(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PD_CART_CHECKOUT_BUTTON_CLICKED"
    }, data));
}
function postCloseCartClicked(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PD_CART_CLOSE_BUTTON_CLICKED"
    }, data));
}
// Checkout
function postCheckoutLoaded(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "CHECKOUT_LOADED"
    }, data));
}
function postPreorderCheckoutStep(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_CHECKOUT_STEP"
    }, data));
}
function postPreorderCheckoutSubmitted(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_CHECKOUT_SUBMITTED"
    }, data));
}
function postPreorderCreated(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_CREATED"
    }, data));
}
function postOrderCreated(data) {
    postMessage(_object_spread({
        type: "ORDER_CREATED"
    }, data));
}
function postPreorderFailed(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "PREORDER_FAILED"
    }, data));
}
function postClosedMessage(data) {
    postMessage((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        type: "CLOSED"
    }, data));
}
// Status
function postCartCleared() {
    postMessage({
        type: "CART_CLEARED"
    });
}
function trackOrderCreated(checkoutViewModel) {
    postOrderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "order"
    }));
}
function trackPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toTrackingOrderObject({
        checkoutViewModel: checkoutViewModel,
        type: "preorder"
    }));
}
function trackCombinedPreorderCreated(checkoutViewModel) {
    postPreorderCreated(toCombinedTrackingOrderObject({
        checkoutViewModel: checkoutViewModel
    }));
}
function postGoToHomepage() {
    postMessage({
        type: "GO_TO_HOME_PAGE"
    });
}
/**
 * Used to build the tracking order object from checkoutViewModel
 * @param { Object } args
 * @param { Object } args.checkoutViewModel
 * @param { ('order'|'preorder') } args.type='preorder'
 * @returns Object
 */ function toTrackingOrderObject() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, checkoutViewModel = ref.checkoutViewModel, _type = ref.type, type = _type === void 0 ? "preorder" : _type;
    var order = type === "preorder" ? checkoutViewModel.preorder : checkoutViewModel.order;
    var lineItems = type === "preorder" ? checkoutViewModel.preorder.lineItems : checkoutViewModel.order.lineItems;
    return {
        reference: order.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        skuId: lineItems[0].sku.id,
        lineItem: {
            sku: lineItems[0].sku.sku,
            properties: lineItems[0].lineItemProperties
        },
        lineItems: lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties
            };
        }),
        total: {
            amount: order.total.amount,
            currency: order.total.currency
        },
        tax: order.tax,
        shipping: order.shipping,
        discountCode: order.discountCode
    };
}
function toCombinedTrackingOrderObject() {
    var checkoutViewModel = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).checkoutViewModel;
    return {
        reference: checkoutViewModel.preorder.reference,
        email: checkoutViewModel.email,
        shippingAddress: checkoutViewModel.shippingAddress,
        lineItems: checkoutViewModel.combinedPreorderOrder.lineItems.map(function(lineItem) {
            return {
                id: lineItem.id,
                skuId: lineItem.sku.externalId,
                skuInternalId: lineItem.sku.id,
                productInternalId: lineItem.product.id,
                productId: lineItem.product.externalId,
                name: lineItem.sku.name,
                quantity: lineItem.quantity,
                price: {
                    amount: lineItem.price.amount,
                    currency: lineItem.price.currency
                },
                sku: lineItem.sku.sku,
                properties: lineItem.lineItemProperties,
                purchaseType: lineItem.purchaseType
            };
        }),
        total: checkoutViewModel.combinedPreorderOrder.total,
        tax: checkoutViewModel.combinedPreorderOrder.tax,
        shipping: checkoutViewModel.combinedPreorderOrder.shipping,
        discountCode: checkoutViewModel.combinedPreorderOrder.discountCode
    };
}
function postMessage(data) {
    window.parent.postMessage(data, "*");
}


/***/ }),

/***/ 57565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7464);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62546);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  transition: all 0.3s linear;\n\n  text-transform: uppercase;\n\n  background-color: ",
        ";\n  color: ",
        ";\n  letter-spacing: ",
        ";\n\n  &:disabled {\n    color: ",
        ";\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ThemedButton = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button */ .ZP.button(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.button.enabled.backgroundColor;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.enabled.letterSpacing;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.color;
}, function(param) {
    var theme = param.theme;
    return theme.button.disabled.backgroundColor;
});
/* harmony default export */ __webpack_exports__["Z"] = (ThemedButton);


/***/ }),

/***/ 62540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fB": function() { return /* binding */ BelowMobile; }
/* harmony export */ });
/* unused harmony exports MOBILE_THRESHOLD, AboveLaptop, AboveMobile, BelowContainer, BelowContainerWithPadding */
var MOBILE_THRESHOLD = 750;
var AboveLaptop = "@media screen and (min-width: 1440px)";
var BelowMobile = "@media screen and (max-width: ".concat(750, "px)");
var AboveMobile = "@media screen and (min-width: ".concat(750, "px)");
var BelowContainer = "@media screen and (max-width: 1200px)";
var BelowContainerWithPadding = "@media screen and (max-width: 1320px)";


/***/ }),

/***/ 9743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46738);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23670);
/* harmony import */ var _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69502);
/* harmony import */ var react_use_measure__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50813);





/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var options = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _param);
    return (0,react_use_measure__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
        polyfill: _juggle_resize_observer__WEBPACK_IMPORTED_MODULE_0__/* .ResizeObserver */ ["do"]
    }));
};
;


/***/ })

}]);